export const ExpressReplacementTransitions = {
  BACK: {
    target: '#RESOLUTION_OPTION',
  },
  SET_XR_DATA: {
    actions: 'storeXrData',
  },
  ERROR: {
    target: '.LOADING_FAILED',
  },
  STORE_SHIPMENT: {
    actions: 'storeShipment',
  },
  GO_TO_DATA_REMOVAL: {
    target: '.DATA_REMOVAL_INTRO',
  },
  GO_TO_PICTURES: {
    target: '.PICTURES',
  },
  GO_TO_DESCRIPTION: {
    target: '.DESCRIPTION',
  },
  GO_TO_PAYMENT: {
    target: '.IDLE',
  },
}
